var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import ngCookies from 'angular-cookies';
import ngSanitize from 'angular-sanitize';
import ngTranslate from 'angular-translate';
import { NgModule } from 'angular-ts-decorators';
export const SUPPORTED_LANGUAGES_INJECTION_TOKEN = 'SUPPORTED_LANGUAGES';
let LocaleModule = class LocaleModule {
    // Minification-safe CI injections, everything @Inject()ed somewhere must be mentioned here:
    static $inject = ['$translate', '$cookies'];
    static run($translate, $cookies) {
        $translate.fallbackLanguage('en');
        // "$cookies" can only used in "run" phase, not in "config" phase!
        $translate.use($cookies.get('locale') || 'en');
    }
};
LocaleModule = __decorate([
    NgModule({
        id: 'LocaleModule',
        imports: [ngCookies, ngSanitize, ngTranslate],
        declarations: [],
        providers: [
            {
                provide: SUPPORTED_LANGUAGES_INJECTION_TOKEN,
                useValue: ['de', 'en', 'fr', 'it', 'es'],
            },
        ],
        bootstrap: [],
    })
], LocaleModule);
export { LocaleModule };
